/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "bodytext_colors_default": "",
  "bodytext_size_default": "@container max-w-article mx-auto w-full pt-0",
  "bodytext_variant_default": "prose",
  "recommended_colors_default": "",
  "recommended_size_default": "gap-y-4 sm:gap-y-6",
  "recommended_variant_default": "flex flex-col",
  "colors_default": "",
  "size_default": "my-3 px-grid-m gap-y-4 sm:gap-y-6",
  "variant_default": "flex flex-col group/article @container"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Article");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;